import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "collage-wrapper" }
const _hoisted_2 = {
  ref: "containerRef",
  class: "collage-container"
}
const _hoisted_3 = { ref: "canvas" }
const _hoisted_4 = {
  key: 0,
  class: "btn"
}
const _hoisted_5 = {
  key: 1,
  class: "btn"
}
const _hoisted_6 = {
  key: 5,
  class: "checkbox"
}
const _hoisted_7 = {
  key: 6,
  class: "checkbox"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_button = _resolveComponent("app-button")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_AppCheckbox = _resolveComponent("AppCheckbox")!
  const _component_app_popover_item = _resolveComponent("app-popover-item")!
  const _component_app_popover_wrapper = _resolveComponent("app-popover-wrapper")!
  const _component_app_popover = _resolveComponent("app-popover")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("canvas", _hoisted_3, null, 512)
      ], 512),
      _createElementVNode("section", {
        class: _normalizeClass(["buttons", { isMobile: _ctx.isMobile }])
      }, [
        (!_ctx.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_app_button, {
                raised: "",
                title: "pickPhoto",
                severity: "secondary",
                icon: ['fas', 'sliders'],
                onClick: _ctx.openImageSettingsModal
              }, null, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_app_button, {
                severity: "success",
                title: "download",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.saveImage('collage')))
              })
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isMobile)
          ? (_openBlock(), _createBlock(_component_app_button, {
              key: 2,
              severity: "warning",
              title: "saveToGallery",
              loading: _ctx.isSaveToGallery,
              onClick: _ctx.saveToGallery
            }, null, 8, ["loading", "onClick"]))
          : _createCommentVNode("", true),
        (!_ctx.isMobile)
          ? (_openBlock(), _createBlock(_component_app_button, {
              key: 3,
              severity: "info",
              title: "addSign",
              onClick: _ctx.openImageModal
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (_ctx.isMobile)
          ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
              key: 4,
              icon: ['fas', 'ellipsis-h'],
              size: "xl",
              onClick: _withModifiers(_ctx.openPopover, ["stop"])
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (!_ctx.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_AppCheckbox, {
                modelValue: _ctx.sharedWithMask,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.sharedWithMask) = $event)),
                label: "shareImageWithMask"
              }, null, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_AppCheckbox, {
                modelValue: _ctx.rememberChoose,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.rememberChoose) = $event)),
                label: "rememberChoose"
              }, null, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _createVNode(_component_app_popover, {
      visible: _ctx.visiblePopover,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.visiblePopover) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_app_popover_wrapper, null, {
          default: _withCtx(() => [
            _createVNode(_component_app_popover_item, { onClick: _ctx.openImageSettingsModal }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  size: "xl",
                  icon: ['fas', 'sliders']
                }),
                _createElementVNode("span", null, _toDisplayString(_ctx.t('pickPhoto')), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_app_popover_item, {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.saveImage('collage')))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  size: "xl",
                  icon: ['fas', 'download']
                }),
                _createElementVNode("span", null, _toDisplayString(_ctx.t('download')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_app_popover_item, { onClick: _ctx.saveToGallery }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  size: "xl",
                  icon: ['fas', 'images']
                }),
                _createElementVNode("span", null, _toDisplayString(_ctx.t('saveToGallery')), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_app_popover_item, { onClick: _ctx.openImageModal }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  size: "xl",
                  icon: ['fas', 'fa-pencil-square']
                }),
                _createElementVNode("span", null, _toDisplayString(_ctx.t('addSign')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_app_popover_wrapper, null, {
          default: _withCtx(() => [
            _createVNode(_component_app_popover_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_AppCheckbox, {
                  modelValue: _ctx.sharedWithMask,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.sharedWithMask) = $event))
                }, null, 8, ["modelValue"]),
                _createElementVNode("span", null, _toDisplayString(_ctx.t('shareImageWithMask')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_app_popover_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_AppCheckbox, {
                  modelValue: _ctx.rememberChoose,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.rememberChoose) = $event))
                }, null, 8, ["modelValue"]),
                _createElementVNode("span", null, _toDisplayString(_ctx.t('rememberChoose')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}